import { Button, Container, FloatingLabel, Form, InputGroup, Modal, Row } from "react-bootstrap";
import { PolicyDto } from "../../model/PolicyDto";
import { Column, DateTimePicker, Icon, Label, Panel, Select } from "../../../components";
import * as labelconstant from '../../../shared/util/label';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../shared/store";
import { useEffect, useState } from "react";
import { SelectOption } from "../../../shared/components/input";
import { CommonUtility } from "../../../Services/CommonUtility";
import DatePicker from "react-datepicker";
import LookupService from "../../../Services/LookupService";
import * as constant from '../../../shared/util/constant';
import { PolicyEventDto } from "../../model/PolicyEventDto";
import { PolicyTransactionPremiumDto } from "../../model/PolicyTransactionPremiumDto";
import CustomerPolicyActionService from "./CustomerPolicyActionService";
import { updateLookupData } from "../../customer-slice/Customer-lookup-slice";
import { PolicyTransactionsReadDto } from "../../model/PolicyTransactionsReadDto";
import { useHistory } from "react-router-dom";
import { storeCustomerPolicies } from "../../customer-slice/Customer-slice";
import { toast } from "react-toastify";
import { ConfirmModal } from "../../../shared/components/confirmModal";
import './Customer-Policy-Action.scss';
import Logger from "../../../shared/services/Logger";
import CustomerPolicyListService from "../CustomerPolicyListService";
import CustomerPolicyDetailViewService from "../customer-policy-detail-view/CustomerPolicyDetailViewService";
import { PolicyLOBReadDto } from "../../model/PolicyLOBReadDto";

export interface ICustomerPolicyActionCancel {
    selectedTransaction: string;
    defaultPolicyDto: PolicyDto;   
    selectedAction: string;
    onCloseModal: () => void;
}
interface ICustomerPolicyActionComponentState {
             id: string,
             custId:string,
             policyNumber: string,            
             fromEffectiveDate: Date,           
             selectedTransactionType: string,
             selectedCancellationReason: string,
             description: string,
             premium:number,
            }
const CustomerPolicyCancelEndorse: React.FunctionComponent<ICustomerPolicyActionCancel> = (props) => {
       const {selectedTransaction, defaultPolicyDto, selectedAction, onCloseModal } = props;
       const dispatch = useDispatch();
       const history = useHistory();
       let transactionTypeData = useSelector((state: RootState) => state?.LookupState.transactionTypeList);
       let cancellationReasonData = useSelector((state: RootState) => state?.LookupState.cancellationReasonList);
       const [transactionTypes, setTransactionTypes] = useState<SelectOption[]>([]);
       const [cancellationReason, setCancellationReason] = useState<SelectOption[]>([]);  
       const [description, setDescription] = useState<string>('');    
       const [formValidation, setFormValidation] = useState<any>({});  
       const policies = useSelector((state: RootState) => state?.customerSlice.policies); 
       const [showConfirmModal, setShowConfirmModal] = useState(false);
        const [policyTransaction, setPolicyTransaction] = useState<PolicyTransactionsReadDto>();  
       
        const policyActionService = new CustomerPolicyActionService();

      let newPolicyComponentInitData: ICustomerPolicyActionComponentState = {
        id:defaultPolicyDto.id,
        custId: defaultPolicyDto.custId || '',
        policyNumber: defaultPolicyDto.policyNumber || '',       
        fromEffectiveDate: defaultPolicyDto.polEffDate,
        selectedTransactionType: selectedTransaction ||'',
        selectedCancellationReason: '',
        description: '',
        premium:null,       
     }
    const [newPolicyComponentData, setNewPolicyComponentData]  = useState<ICustomerPolicyActionComponentState>(newPolicyComponentInitData);
    let initializeComponent = async ()  => {   
        let lookupData = {
                transactionTypeLookup: [],
                canellationReasonLookup: []               
            };

            if (transactionTypeData.length === 0 ){
               let transactionTypes = await LookupService.fetchTransactionType(); 
            //    transactionTypeData = CommonUtility.mapToSelectOptions(transactionTypes);
                transactionTypeData = transactionTypes ? transactionTypes.map(item => {
                return {
                    label: item.lookupValue,
                    value: item.lookupCode || item.id,
                    isInactive: false
                }}) : [];
                dispatch(updateLookupData({ data: transactionTypeData, type: constant.SlicerLookUpConstant.Transaction_Type }));
                lookupData.transactionTypeLookup = transactionTypeData;
            }
            else {
                lookupData = {                    
                    transactionTypeLookup: [...transactionTypeData],
                    canellationReasonLookup: [...cancellationReasonData],
                };
            }

            setTransactionTypes(
                           lookupData.transactionTypeLookup.map((type: SelectOption) => ({
                               ...type,
                               label: CommonUtility.capitalizeFirstCharOfEachWord(type.label),
                           }))
                       );
                       
            // fetch cancelllation reason list in case of cancel policy (not policy endorse)
           if (selectedAction === constant.policyActionConstant.CANCELLATION && cancellationReasonData.length === 0 ){             
                cancellationReasonData = await policyActionService.getCancellationReason();
                dispatch(updateLookupData({ data: cancellationReasonData, type: constant.SlicerLookUpConstant.Cancellation_Reason }));
                lookupData.canellationReasonLookup = cancellationReasonData;
            }
            else {
                lookupData = {
                    transactionTypeLookup: [...transactionTypeData],
                    canellationReasonLookup: [...cancellationReasonData]
                };
            }    

            setCancellationReason(
                lookupData.canellationReasonLookup?.map((type: SelectOption) => ({
                    ...type,
                    label: CommonUtility.capitalizeFirstCharOfEachWord(type.label),
                }))
            );   
        }

    useEffect(() => {
            initializeComponent();
        }, []);     
     
    
            
    const handleSavePolicy =async(data: any) =>{
          
                      let tranType= '';
                      let transNote = newPolicyComponentData.description;
                      let premium = 0;
                      let isCancel = selectedAction === constant.policyActionConstant.CANCELLATION ? true:false;
                      let subTranType ='';
                     try{
                       switch (selectedAction) {
                                  case constant.policyActionConstant.CANCELLATION:
                                      tranType = constant.EventTransactionType.XLC;
                                      transNote = transNote;                                      
                                      break;
                                  case constant.policyActionConstant.ENDORSE: 
                                      tranType = constant.EventTransactionType.PCH;   
                                      transNote = constant.UPDATED_TRANS;//transNote;
                                      subTranType = constant.policyActionConstant.ENDORSE;                                
                                      break;                                
                                  default:
                                     return                                      
                              }

                              // assign selected tranType with dropdown selection if available
                              if (tranType === constant.EventTransactionType.XLC && data.selectedTransactionType && data.selectedTransactionType.trim().length > 0) {
                                  subTranType = data.selectedTransactionType;
                              }
                            

                        let updatedPolicyEvents = Array.isArray(defaultPolicyDto.policyEvents) ? [...defaultPolicyDto.policyEvents] : [];
                        
                        if (updatedPolicyEvents.length > 0) {
                            let latesteventIndex = updatedPolicyEvents.length - 1;
                            updatedPolicyEvents[latesteventIndex] = {
                                ...updatedPolicyEvents[latesteventIndex],
                                tranType: tranType,
                                carrierTransactionEnteredDate: new Date().toISOString(),
                                tranEffDate: data.fromEffectiveDate !== null ? CommonUtility.datetimeToDateOnly(data.fromEffectiveDate) : null,
                                tranNote: transNote,
                                cancellationReasonId: isCancel ? data.selectedCancellationReason : updatedPolicyEvents[latesteventIndex].cancellationReasonId    
                            };
                            // if(isCancel){
                            //     updatedPolicyEvents[latesteventIndex].fullTermPremium = data.premium;
                            // } 
                        } else {
                            console.log("No existing policy event found to update.", defaultPolicyDto.policyEvents);
                            toast.error(labelconstant.PolicyActionLabels.ERROR_MESSAGE, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                            return;
                        }
             
                              const policyTransactionPremium: PolicyTransactionPremiumDto[] = [{
                                  premium: isCancel ? data.premium : premium,
                                  effDate: data.fromEffectiveDate !== null ? CommonUtility.datetimeToDateOnly(data.fromEffectiveDate) : null,
                              }];
                              
                        const existingInsureds = defaultPolicyDto.policyInsureds || [];
                        const existingCoInsureds = defaultPolicyDto.policyCoInsureds || [];
                        const existingLOBs = defaultPolicyDto.policyLineOfBusinesses || [];
                       
                        
                         const policyLOBs: PolicyLOBReadDto[] = [{
                                            id: constant.DEFAULT_GUID,
                                            polId : constant.DEFAULT_GUID,
                                            lobCode: "",
                                            lobCodeId: defaultPolicyDto.polTypeLobId,
                                            effDate: defaultPolicyDto.polEffDate,
                                            expDate: defaultPolicyDto.polExpDate,
                                            polEventId: constant.DEFAULT_GUID,
                                            policyCoverages: [],
                                            policyAdditionalInterests: [],
                                            policyLocations: [],
                                        }];
                        
                        const updatedPolicy: PolicyDto = {
                            ...data,
                            fullTermPremium: defaultPolicyDto.fullTermPremium,
                            polEffDate: defaultPolicyDto.polEffDate,
                            policyEvents: updatedPolicyEvents,
                            policyTransactionPremiums: policyTransactionPremium,
                            polExpDate: defaultPolicyDto.polExpDate,
                            sourceId: defaultPolicyDto.sourceId,
                            sourceTypeId: defaultPolicyDto.sourceTypeId,
                            typeOfBusId: defaultPolicyDto.typeOfBusId,
                            polTypeLobId: defaultPolicyDto.polTypeLobId,
                            issuedState: defaultPolicyDto.issuedState,
                            companyId: defaultPolicyDto.companyId,
                            writingCompanyId: defaultPolicyDto.writingCompanyId,
                            policyTypeId: defaultPolicyDto.policyTypeId,
                            policyLineOfBusinesses: existingLOBs.length > 0 ? [...existingLOBs] : policyLOBs,
                            policyInsureds: [...existingInsureds],
                            policyCoInsureds: [...existingCoInsureds],
                            policyExt: { subTranType: subTranType }
                        };
                    
                     let validationError = policyActionService.validatePolicyCancel(updatedPolicy, isCancel);  
                     if ((!newPolicyComponentData.selectedTransactionType) || newPolicyComponentData.selectedTransactionType.trim().length == 0) {                               
                            validationError['transactionDD'] = {isValid : false, warningText :  constant.policyActionSummaryConstant.Customer_Policy_Action_MANDATORY};
                        }                            
                      setFormValidation(validationError);
                      if (Object.keys(validationError).length > 0) {
                      toast.warn(constant.CUSTOMER_FORM_VALIDATION_ERROR_MESSAGE, {
                          position: toast.POSITION.TOP_RIGHT
                      });
                      return;
                      }

                        let response = await policyActionService.savePolicyTransaction(tranType, updatedPolicy);

                        const customerPolicyListService = new CustomerPolicyListService();
                        const updatedPolicies = await customerPolicyListService.fetchCustomerPolicyDetails(data.custId);
                        dispatch(storeCustomerPolicies(updatedPolicies));
                                
                        const customerPolicyDetailViewService = new CustomerPolicyDetailViewService();
                        let responseTransactionDetails = await customerPolicyDetailViewService.getTransactionsDetails(response?.policy?.id); 
                        setPolicyTransaction(responseTransactionDetails[0]);
                        setShowConfirmModal(true);
                    }
                    catch (error) {
                         Logger.logError(error.toString()); 
                        toast.error(labelconstant.PolicyActionLabels.ERROR_MESSAGE, {
                        position: toast.POSITION.TOP_RIGHT,
                        });
                        setShowConfirmModal(false);                      
                    } 
    }

     const onEntityFieldChange = (propName: string, value: string | Date | boolean) => {   
      if(propName === "description")
        {
            setDescription(value.toString());
        }  

        if(propName === "premium"){
           value = CommonUtility.validateDecimal(value.toString());
        }

       setNewPolicyComponentData((prevState) => ({
          ...prevState,
            [propName]: value,
        }));
      }      

      const onOkayClick =(policyTransactionClicked: PolicyTransactionsReadDto) =>{
         history.push(`/customer-view/policy-details/${newPolicyComponentData.custId}/${newPolicyComponentData.id}/${policyTransactionClicked?.polEventId}`, { policyTransactionClicked:policyTransactionClicked, policyId:newPolicyComponentData.id});   
      }
       
return (
        <>
        <Container fluid className="mt-4">
        <Row style={{ display: 'flex' }}>
                        <Column>
                         <Row>                  
                           {(selectedAction === constant.policyActionConstant.CANCELLATION) && (    <Label className='inlineLable mb-3' text={labelconstant.PolicyActionLabels.CANCELLATION_LABEL} />    )} 
                           {(selectedAction === constant.policyActionConstant.ENDORSE) && (    <Label className='inlineLable mb-3' text={labelconstant.PolicyActionLabels.ENDORSE_LABEL} />    )} 

                        </Row>
                        
                        <Row>
                            <Column lg={6}>
                                                   <Select
                                                        id="transactionDD"
                                                        controlId="transactionDD"
                                                        className='mb-2'
                                                        label={<>{labelconstant.PolicyActionLabels.TRANSACTION_TYPE}<span className="text-danger ms-1">*</span></>}
                                                        options={transactionTypes}
                                                        defaultSelected={transactionTypes.filter(option =>
                                                            option.value === newPolicyComponentData.selectedTransactionType
                                                        )}
                                                        onChange={(values) => onEntityFieldChange('selectedTransactionType', values[0] as string)} 
                                                        disabled={false}
                                                        tabIndex={10}
                                                        isInvalid={formValidation['transactionDD']?.isValid == false}
                                                        invalidWarning={formValidation['transactionDD']?.warningText}
                                                    />
                       
                     </Column>
              <Column lg={6}>
                                                <InputGroup className="mb-3">
                                                                            <InputGroup.Text>
                                                                                {labelconstant.PolicyActionLabels.EFFECTIVE_DATE}
                                                                            </InputGroup.Text>
                                                                            <DatePicker
                                                                                dateFormatCalendar="LLLL yyyy"
                                                                                dropdownMode="scroll"
                                                                                selected={CommonUtility.datetimeToDateOnlyObject(newPolicyComponentData.fromEffectiveDate)}
                                                                                onChange={(date) => onEntityFieldChange('fromEffectiveDate', date)}
                                                                                className="form-control"
                                                                                isRequired={true}                                                                                
                                                                            />
                                                                            <InputGroup.Text>
                                                                                <i className="bi bi-calendar3"></i>
                                                                            </InputGroup.Text>
                                                                             {formValidation['fromEffectiveDate']?.isValid === false && (
                                                                                    <div className="invalid-feedback dateTimePickerErrDiv">
                                                                                        {formValidation['fromEffectiveDate']?.warningText}
                                                                                    </div>
                                                                                )}
                                                                        </InputGroup>

                         </Column>                       
                 </Row>
              {(selectedAction === constant.policyActionConstant.CANCELLATION) && (    <Row>
                                     <Column>
                                                                                 <Select
                                                                                     id="cancelReason"
                                                                                     controlId="cancelReason"
                                                                                     className='mb-3'
                                                                                     label={<>{labelconstant.PolicyActionLabels.CANCELLATION_REASON_LABEL}<span className="text-danger ms-1">*</span></>}
                                                                                     options={cancellationReason}                                                                    
                                                                                     defaultSelected={cancellationReason.filter(option =>
                                                                                           option.value === newPolicyComponentData.selectedCancellationReason
                                                                                       )}
                                                                                     onChange={(values) => onEntityFieldChange('selectedCancellationReason', values[0] as string)}                                                                  
                                                                                     disabled={false}
                                                                                     tabIndex={10}
                                                                                     isInvalid={formValidation['selectedCancellationReason']?.isValid == false}
                                                                                     invalidWarning={formValidation['selectedCancellationReason']?.warningText}
                                                                                 />
                                     </Column>
                     </Row>
              )}
                     <Row className="mb-3">
                                       <Column>
                                                         <FloatingLabel
                                                             controlId="descriptionTxt"
                                                             label={
                                                                 <>
                                                                     {labelconstant.PolicyActionLabels.DESCRIPTION}
                                                                     <span className="text-danger">*</span>
                                                                 </>
                                                             }>                                        
                                                             <Form.Control
                                                                 type="text"
                                                                 name="description"
                                                                 placeholder={labelconstant.PolicyActionLabels.DESCRIPTION}
                                                                 value={newPolicyComponentData.description || ""}
                                                                 onChange={(event) => onEntityFieldChange('description', event.currentTarget.value)}
                                                                 disabled={false} // Set to true if the field should be non-editable
                                                                 maxLength={300}
                                                                 width={200}
                                                                 required={true}
                                                                 isInvalid={formValidation['description']?.isValid == false}
                                                                 tabIndex={1}
                                                             />
                                                             <Form.Control.Feedback type="invalid">
                                                                 {formValidation['description']?.warningText}
                                                             </Form.Control.Feedback>
                                                         </FloatingLabel>
                                                     
                                                 </Column>
                                                 </Row>
                                                  {(selectedAction === constant.policyActionConstant.CANCELLATION) && <Row>
                                                      <Column>
                                                         <FloatingLabel
                                                             controlId="PolicyPremiunm"
                                                             label={
                                                                 <>
                                                                     {labelconstant.PolicyActionLabels.PREMIUM}
                                                                     <span className="text-danger">*</span>
                                                                 </>
                                                             }>                                        
                                                             <Form.Control
                                                                 type="number"
                                                                 name="premium"
                                                                 placeholder={labelconstant.PolicyActionLabels.PREMIUM}
                                                                 value={newPolicyComponentData.premium || ""}
                                                                 onChange={(event) => onEntityFieldChange('premium', event.currentTarget.value)}
                                                                 disabled={false}
                                                                 maxLength={300}
                                                                 width={200}
                                                                 required={true}
                                                                 isInvalid={formValidation['premium']?.isValid == false}
                                                                 tabIndex={1}
                                                                 step="any"  // Allows decimal values
                                                             />
                                                             <Form.Control.Feedback type="invalid">
                                                                 {formValidation['premium']?.warningText}
                                                             </Form.Control.Feedback>
                                                         </FloatingLabel>
                                                     
                                                         </Column>
                                                 </Row>
                                                    }
                        </Column>
                        </Row>
         <Row className="mt-4 justify-content-end">
                <Column lg={2} className="d-flex justify-content-end">
                    <button
                        className="btn btn-primary me-2"
                        onClick={() => 
                           onCloseModal()
                        }
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={() => handleSavePolicy(newPolicyComponentData)}
                    >
                        Submit
                    </button>
                </Column>
            </Row>             

            <ConfirmModal
                modaltitle={labelconstant.PolicyActionLabels.CANCELLATION_POPUP_HEADER}
                showConfirmation={showConfirmModal}
                setConfirmation={() => onOkayClick(policyTransaction)}
                body={ <div>
                {(selectedAction === constant.policyActionConstant.CANCELLATION) && (<Label className='inlineLable' text={labelconstant.PolicyActionLabels.CANCELLATION_SUBMIT_MESSAGE} />    )} 
                {(selectedAction === constant.policyActionConstant.ENDORSE) && (<Label className='inlineLable' text={labelconstant.PolicyActionLabels.ENDORSEMENT_SUBMIT_MESSAGE} />    )} 
                <Row className="mt-0 justify-content-end">     
                        <Column lg={2} className="d-flex justify-content-end">
                         <button
                            className="btn btn-primary"
                            onClick={() => onOkayClick(policyTransaction)}
                        >
                            Okay
                        </button>
                        </Column>           
                        </Row>
                    </div>  }
                hideButtons={true} 
                closeButtonLabel={""} 
                successButtonLabel={"Ok"}    
            />


            
        </Container>
        </>
        );
};
export default CustomerPolicyCancelEndorse;
